<template>
  <div class="login-container">
    <el-row class="form-row">
      <el-col class="el-col-form" :span="8" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="login-form"
          label-position="left"
        >
          <div class="title-tips">
            <div class="rt-icon-box"></div>
            <div class="title-name-box">{{ title }}</div>
          </div>
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item style="margin-top: 45px;margin-bottom: 0;" prop="username">
                <span class="svg-container svg-container-admin">
                  <i class = "iconfont icon-zhanghu"></i>
                </span>
                <el-input
                  placeholder="请输入账号"
                  v-model.trim="form.username"
                  tabindex="1"
                  type="text"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item prop="password">
                <span class="svg-container">
                  <i class = "iconfont icon-mima1"></i>
                </span>
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model.trim="form.password"
                  :type="passwordType"
                  tabindex="2"
                  placeholder="请输入密码"
                  @keyup.enter.native="handleLogin"
                />
                <span
                  v-if="passwordType !== 'password' && form.password"
                  class="show-password"
                  @click="handlePassword"
                >
                <i class = "iconfont icon-mimakejian"></i>
                </span>
                <span v-if="passwordType === 'password' && form.password" class="show-password" @click="handlePassword">
                  <i class = "iconfont icon-mimabukejian"></i>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="btn-row">
            <el-button
              :loading="loading"
              class="login-btn"
              type="primary"
              @click="handleLogin"
            >
              登录
            </el-button>
          </el-row>
          <!-- <p class="forget-password">忘记密码</p> -->
        </el-form>
      </el-col>
      <el-col class="el-col-ikon"></el-col>
    </el-row>
    <div class="footer">Copyright © 2020-2023 Happay All Rights Reserved.</div>
  </div>
</template>

<script>
  import { isPassword } from '@/utils/validate'
  import { resetRouter, constantRoutes, asyncRoutes } from '@/router'
  import { getStorage } from '@/utils/index'
  export default {
    name: 'Login',
    directives: {
      focus: {
        inserted(el) {
          el.querySelector('input').focus()
        },
      },
    },
    data() {
      const validateusername = (rule, value, callback) => {
        if ('' == value) {
          callback(new Error('账号不能为空'))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (!isPassword(value)) {
          callback(new Error('密码不能为空'))
        } else {
          callback()
        }
      }
      return {
        nodeEnv: process.env.NODE_ENV,
        title: this.$baseTitle,
        form: {
          username: '',
          password: '',
        },
        rules: {
          username: [
            {
              required: true,
              trigger: 'blur',
              validator: validateusername,
            },
          ],
          password: [
            {
              required: true,
              trigger: 'blur',
              validator: validatePassword,
            },
          ],
        },
        loading: false,
        passwordType: 'password',
        redirect: undefined,
      }
    },
    watch: {
      $route: {
        handler(route) {
          this.redirect = (route.query && route.query.redirect) || '/'
        },
        immediate: true,
      },
    },
    created() {
      document.body.style.overflow = 'hidden'
    },
    beforeDestroy() {
      document.body.style.overflow = 'auto'
    },
    mounted() {
      console.log()
      if ( this.nodeEnv == 'development') {
        this.form.username = 'admin@happay.test'
        this.form.password = '000000'
      }
      let account = localStorage.getItem('account')
      console.log(localStorage.getItem('account'))
      this.form.username = account
      setTimeout(() => {
        // this.handleLogin()
      }, 3000)
    },
    methods: {
      handlePassword() {
        this.passwordType === 'password'
          ? (this.passwordType = '')
          : (this.passwordType = 'password')
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      },
      handleLogin() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true
            let data = JSON.parse(JSON.stringify(this.form))
            this.$store
              .dispatch('user/login', data)
              .then(async () => {
                console.log('进入系统')
                const permissions = getStorage('USER_PERMISSIONS')
                var routerArr = [...asyncRoutes, ...constantRoutes]
                routerArr = routerArr.filter((item) => {
                  return !item.hidden
                })
                routerArr = routerArr.filter((item) => {
                  let noHidden = false
                  let curChildren = []
                  if(permissions.indexOf(item.path) >= 0) {
                    curChildren = item.children.filter(item2 => permissions.indexOf(item2.path) >= 0)
                    item.children = curChildren
                    noHidden = true
                  }
                  return noHidden
                })
                const routerPath = routerArr[0].children[0].path
                this.$router.push({
                  path: routerPath,
                  name: routerArr[0].children[0].name
                }).catch(() => {})
                const loadingInstance = this.$baseLoading(6)
                setTimeout(async () => {
                  await resetRouter()
                  loadingInstance.close()
                }, 2000)
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            return false
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .login-container {
    height: 100vh;
    background: url('~@/assets/login_images/login-bg.png') center center no-repeat;
    background-size: 100% 100%;

    .title {
      font-size: 54px;
      font-weight: 500;
      color: rgba(14, 18, 26, 1);
    }

    .title-tips {
      display: flex;
      justify-content: center;
      align-items: center;

      .rt-icon-box {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        background: url('~@/assets/login_images/rt-icon.png') no-repeat;
        background-size: 100% 100%;
      }

      .title-name-box {
        font-size: 26px;
        font-weight: 500;
        color: #333333;
        white-space: nowrap;
        height: 30px;
        line-height: 34px;
      }
    }
    .btn-row{
      .login-btn {
        width: 100%;
        height: 40px;
        margin-top: 5px;
        border: 0;
        &:hover {
          opacity: 0.9;
        }
      }
    }

    .form-row {
      height: 100%;
      position: relative;
    }

    .el-col-form{
      width: 20%;
      position: relative;
      left: 30%;
      top: 50%;
      transform:translate(-50%,-50%);
      overflow: hidden;
      box-sizing: border-box;

      .login-form {
        text-align: center;

        .forget-password {
          height: 24px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 24px;
          text-align: center;
          cursor: pointer;
        }
      }
    }

    .el-col-ikon {
      width: 40%;
      height: 100%;
      background: url('~@/assets/login_images/login-ikon.png') center center no-repeat;
      background-size: contain;
      position: absolute;
      left: 76%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .tips {
      margin-bottom: 10px;
      font-size: $base-font-size-default;
      color: $base-color-white;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }
    .title-container {
      position: relative;

      .title {
        margin: 0 auto 40px auto;
        font-size: 34px;
        font-weight: bold;
        color: $base-color-blue;
        text-align: center;
      }
    }
    .svg-container {
      position: absolute;
      top: 5px;
      left: 15px;
      z-index: $base-z-index;
      font-size: 16px;
      color: #666;
      cursor: pointer;
      user-select: none;
    }
    .show-password {
      position: absolute;
      top: 5px;
      right: 15px;
      font-size: 16px;
      color: #666;
      cursor: pointer;
      user-select: none;
    }
    .form-item-col{
      // padding: 0 23%;
    }
    ::v-deep {
      .el-form-item {
        display: inline-block;
        padding-right: 0;
        margin: 20px 0;
        border-radius: 2px;
        // max-width: 340px;
        width: 100%;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        &__content {
          min-height: $base-input-height;
          line-height: $base-input-height;
        }

        &__error {
          position: absolute;
          top: 100%;
          left: 18px;
          font-size: $base-font-size-small;
          line-height: 18px;
          color: $base-color-red;
        }
      }

      .el-input {
        box-sizing: border-box;
        input {
          height: 40px;
          padding-left: 55px;
          font-size: 14px;
          line-height: 40px;
          color: #333;
          background: #fff;
          border: 0;
        }
      }
    }
    .footer{
      position: fixed;
      left: 30%;
      bottom: 12%;
      transform: translateX(-50%);
      font-size: 14px;
      color: #999999;
      text-align: center;
    }
  }
</style>
